import './LocationSelector.scss';
import { useEffect, useRef, useState, FC, useContext } from 'react';
import { Icon } from '../../Icon/Icon';
import classNames from 'classnames';
import { locationTitle as getLocationTitle } from './utils/getLocationTitle';
import { useOnClickOutside } from 'usehooks-ts';
import { useGetMyLocations } from '../../../Hooks/LocationHooks';
import { LocationContext } from '../../../../Core/Contexts/LocationContext';

type Props = {
	locationId: number;
	handleChange: (args: number) => void;
};

export const LocationSelector: FC<Props> = ({
	locationId,
	handleChange,
}) => {

	const { data: locations } = useGetMyLocations();
	const [showOptions, setShowOptions] = useState(false);
	const [currentLocation, setCurrentLocation] = useContext(LocationContext);
	const [selectedLocation, setSelectedLocation] = useState(currentLocation);
	
	const ref = useRef(null);

	useEffect(() => {
		if (!selectedLocation && locations) {
			setSelectedLocation(locations[0].id);
			handleChange(locations[0].id);
		}
	}, [locations, selectedLocation, setSelectedLocation]);

	useEffect(() => {
		if (locationId) {
			setSelectedLocation(parseInt(locationId.toString()));
			handleChange(parseInt(locationId.toString()));
		}
	}, [locationId]);

	//!temporary Sends everyone back to orders
	const handleLocationSelected = (
		locationId: number,
	) => {
		setSelectedLocation(locationId);
		handleChange(locationId)
	};

	// Hide the popup when clicking outside the popup
	const handleClickOutside = () => {
		setShowOptions(false);
	};

	// Toggle the popup
	const handleOptionsClick = () => {
		setShowOptions(!showOptions);
	};

	// Setup on outside click handler
	useOnClickOutside(ref, handleClickOutside);

	if (!locations) {
		return null;
	}

	const locationTitle = getLocationTitle(locations, selectedLocation);

	return (
		<div className="locationSelector-wrapper" ref={ref}>
			{showOptions && (
				<div className="locationSelector-list">
					{locations.map(({ id, title, locationType }) => {
						return (
							locationType === 'production' 
							? '' 
							: 
							<div
								key={id}
								className={classNames('locationSelector-list__item', {
									'is-active': id === selectedLocation,
								})}
								onClick={() => {
									handleLocationSelected(id);
									setShowOptions(!showOptions);
								}}
							>
								{title}
							</div>
							
						);
					})}
				</div>
			)}
			<div className="locationSelector" onClick={handleOptionsClick}>
				<div className="locationSelector__header">{locationTitle}</div>
				<div
					className={classNames('locationSelector__icon', {
						'locationSelector__icon--active': showOptions,
					})}
				>
					<Icon name="Carret" width={11} />
				</div>
			</div>
		</div>
	);
};
